import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledExploreAndPlay = styled.span`
  opacity: ${({ disabled }) => (disabled ? 0.35 : 1)};
  color: ${Colors.textDark};

  span:not(:nth-child(1)) {
    letter-spacing: 1.2px;
    font-weight: 1000;
    text-transform: uppercase;
    font-size: 107%;
    font-family: monospace;
    &:nth-child(2) {
      color: ${Colors.activityTypeColors.worksheet};
    }
    &:nth-child(3) {
      color: #c4007a;
    }
    &:nth-child(4) {
      color: ${Colors.activityTypeColors.song};
    }
    &:nth-child(5) {
      color: ${Colors.activityTypeColors.pictureDictionary};
    }
    &:nth-child(6) {
      color: ${Colors.activityTypeColors.video};
    }
    &:nth-child(7) {
      color: ${Colors.activityTypeColors.craft};
    }
    &:nth-child(8) {
      color: ${Colors.activityTypeColors.interactiveVideo};
    }
  }
`;
